
import './styles.css'
import { MultiSelect } from "primereact/multiselect";

function Multiselect({
    id,
    name,
    options = [],
    value,
    onChange,
    disabled,
    className,
    placeholder,
    display,
    filter,
    showClear,
    label,
    required = false,
    error,
    max,
    touched,
    optionLabel,
    helpText,
    itemTemplate,
    optionValue,

}) {

    const hasError = touched && !!error;

    return (
        <div className="flex flex-col gap-1.5">
            {/* Label */}
            <label
                htmlFor={id}
                className={`text-sm font-medium ${hasError ? "text-destructive" : "text-foreground/80"}`}>
                {label}
                {required && <span className="text-destructive ml-1">*</span>}
            </label>
            <MultiSelect
                id={id}
                name={name}
                value={value || []}
                options={options}
                onChange={onChange}
                optionLabel={optionLabel}
                optionValue={optionValue}
                placeholder={placeholder}
                display={display || "chip"}
                filter={filter}
                max={max}
                maxSelectedLabels={max}
                itemTemplate={itemTemplate}
                showClear={showClear}
                disabled={disabled}
                className={`
                        w-full 
                        border
                        text-sm
                        border-indigo-300 
                        disabled:bg-gray-50 
                        rounded-sm
                        
                        ${hasError
                        ? "p-invalid"
                        : "border border-blue-300 focus:ring-1 focus:ring-blue-500"
                    }
                        ${className}
                        `}
            />
            {hasError ? (
                <span className="text-xs text-destructive">{error}</span>
            ) : helpText ? (
                <span className="text-xs text-muted-foreground">{helpText}</span>
            ) : null}
        </div>
    );
}

export default Multiselect;
